module.exports = __webpack_public_path__ + "static/media/web7.8a5a6859.png";